import { ACTIONS } from "../actions/admin-list-users";

const header = ['名前', 'ログインID', 'グループ名', '備考', ''];
const header1 = ['グループ名', '人数', ''];
const table1 = [
    {
        item: [
            {
                text: '人数'
            },
            {
                text: '12'
            },
            {
                action: [
                    'グループ名変更',
                    '編集',
                    '削除'
                ]
            }
        ]
    },
    {
        item: [
            {
                text: '人数'
            },
            {
                text: '12'
            },
            {
                action: [
                    'グループ名変更',
                    '編集',
                    '削除'
                ]
            }
        ]
    },
    {
        item: [
            {
                text: '人数'
            },
            {
                text: '12'
            },
            {
                action: [
                    'グループ名変更',
                    '編集',
                    '削除'
                ]
            }
        ]
    },
    {
        item: [
            {
                text: '人数'
            },
            {
                text: '12'
            },
            {
                action: [
                    'グループ名変更',
                    '編集',
                    '削除'
                ]
            }
        ]
    },
    {
        item: [
            {
                text: '人数'
            },
            {
                text: '12'
            },
            {
                action: [
                    'グループ名変更',
                    '編集',
                    '削除'
                ]
            }
        ]
    },
    {
        item: [
            {
                text: '人数'
            },
            {
                text: '12'
            },
            {
                action: [
                    'グループ名変更',
                    '編集',
                    '削除'
                ]
            }
        ]
    }
];
const arrButton = ['ユーザーを追加', 'グループを追加'];

export default (state = { header, header1, table1, arrButton }, action) => {
    switch (action.type) {
        case ACTIONS.GET_GROUPS_SUCCESS:
        case ACTIONS.ADD_GROUPS_SUCCESS:
        case ACTIONS.UPDATE_GROUPS_SUCCESS:
        case ACTIONS.REMOVE_GROUP_COMPANY_SUCCESS:
        case ACTIONS.GET_USERS_LIST_GROUPS_SUCCESS:
        case ACTIONS.REMOVE_USERS_GROUP_SUCCESS:
        case ACTIONS.ADD_USERS_GROUPS_SUCCESS:
        case ACTIONS.UPDATE_USERS_GROUPS_SUCCESS:
        case ACTIONS.GET_USERS_LIST_DELETE_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
                responseAdd: action.data.dataAdd,
                message: action.data.message,
                list: action.data,
                meta:action.data.meta,
            };
        case ACTIONS.GET_GROUPS_ERROS:
        case ACTIONS.ADD_GROUPS_ERROR:
        case ACTIONS.UPDATE_GROUPS_ERROS:
        case ACTIONS.REMOVE_GROUP_COMPANY_ERROR:
        case ACTIONS.GET_USERS_LIST_GROUPS_ERROS:
        case ACTIONS.REMOVE_USERS_GROUP_ERROR:
        case ACTIONS.ADD_USERS_GROUPS_ERROR:
        case ACTIONS.UPDATE_USERS_GROUPS_ERROR:
        case ACTIONS.GET_USERS_LIST_DELETE_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
                message: action.data.message,
            }
        default:
            return state;
    }
};